import React, { FC } from "react";
import Slider from "react-slick";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { NotificationBarProps } from "@Types/NotificationBar";
import classes from "./NotificationBar.module.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NotificationBar: FC<NotificationBarProps> = (props) => {
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 8500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "linear",
    swipe: false,
    arrows: false,
  };

  const { items } = props.notifications;
  if (!items?.length) return null;

  return (
    <div className={classes["slider-container"]}>
      <Slider {...settings}>
        {items.map((item, index) => (
          <div key={index}>
            <p className={classes["text-heading"]}>{item.heading}</p>
            <span className={classes["text-content"]}>
              <CmsTextEditorContent content={item.content} />
            </span>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default NotificationBar;
